<div class="team">
  <div class="card">
    <div class="card__header">My Team</div>
    <div class="card__content">
      <div class="status" *ngIf="loading()">Loading…</div>
      <div class="error" *ngIf="errorText()">
        {{ errorText() }}
        <button type="button" class="error__close" (click)="dismissError()">×</button>
      </div>

      <ng-container *ngIf="!loading()">
        <div class="toolbar" *ngIf="teamMembers().length > 0">
          <button type="button" 
                  class="btn btn--primary" 
                  (click)="openBulkAssign()"
                  [disabled]="loading() || teamMembers().length === 0">
            Assign Bulk
          </button>
        </div>

        <div class="muted" *ngIf="teamMembers().length === 0">No team members found.</div>

        <div class="accordion" *ngIf="teamMembers().length > 0">
          <!-- Member accordions directly under the card header (no duplicate 'My Team' row) -->
          <div class="accordion-item" *ngFor="let m of teamMembers()">
            <button type="button"
                    class="accordion-header"
                    (click)="toggleMember(memberKey(m))"
                    [aria-expanded]="isMemberOpen(memberKey(m))">
              <span class="acc-arrow" [class.expanded]="isMemberOpen(memberKey(m))"></span>
              <span class="acc-title">{{ displayName(m) }}</span>
              <span class="muted small">{{ m.LEVEL || '' }}</span>
            </button>

            <div class="accordion-panel" *ngIf="isMemberOpen(memberKey(m))">
              <div class="toolbar narrow">
                <button type="button" class="btn btn--danger btn--sm" (click)="openAssignDialog(memberKey(m))">Assign Course</button>
              </div>
              <div class="status" *ngIf="assignedFor(memberKey(m))?.loading">Loading assigned courses…</div>
              <div class="error" *ngIf="assignedFor(memberKey(m))?.error">{{ assignedFor(memberKey(m))?.error }}</div>

              <ng-container *ngIf="!assignedFor(memberKey(m))?.loading">
                <div class="muted" *ngIf="(assignedFor(memberKey(m))?.courses?.length || 0) === 0">No assigned courses.</div>
                <table class="table narrow" *ngIf="(assignedFor(memberKey(m))?.courses?.length || 0) > 0">
                  <thead>
                    <tr>
                      <th>Course Name</th>
                      <th>Course ID</th>
                      <th>Status</th>
                      <th>Assigned On</th>
                      <th>Completed On</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let c of assignedFor(memberKey(m))?.courses">
                      <td>{{ getCourseName(c.COURSE_ID) }}</td>
                      <td>{{ c.COURSE_ID }}</td>
                      <td><span [class]="badgeClass(c.STATUS)">{{ c.STATUS }}</span></td>
                      <td>{{ c.ASSIGNED_ON || '—' }}</td>
                      <td>{{ c.COMPLETED_ON || '—' }}</td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<!-- Assign Course Dialog -->
<div class="dialog-overlay" *ngIf="assignOpen()" aria-modal="true" role="dialog">
  <div class="dialog">
    <div class="dialog__header">
      <div class="dialog__title">Assign Course</div>
    </div>
    <div class="dialog__content">
      <div class="status" *ngIf="assignLoading()">Loading…</div>
      <div class="error" *ngIf="assignError()">
        {{ assignError() }}
        <button type="button" class="error__close" (click)="dismissAssignError()">×</button>
      </div>

      <ng-container *ngIf="!assignLoading()">
        <div class="muted" *ngIf="availableCourses().length === 0">
          All courses are already assigned to this employee.
        </div>
        <div class="form-row" *ngIf="availableCourses().length > 0">
          <label for="assign-course">Select a course</label>
          <select id="assign-course"
                  class="input"
                  [value]="selectedCourseId()"
                  (change)="onSelectAssignCourse($any($event.target).value)">
            <option value="" disabled>Please select a course</option>
            <option *ngFor="let c of availableCourses()" [value]="c.COURSE_ID">
              {{ c.COURSE_NAME }} ({{ c.COURSE_ID }})
            </option>
          </select>
        </div>
      </ng-container>
    </div>
    <div class="dialog__footer">
      <button type="button" class="btn btn--ghost" (click)="closeAssignDialog()" [disabled]="assignLoading()">Cancel</button>
      <button type="button"
              class="btn btn--success"
              (click)="confirmAssign()"
              [disabled]="assignLoading() || !selectedCourseId() || availableCourses().length === 0">
        Assign
      </button>
    </div>
  </div>
</div>

<!-- Bulk Assign Dialog -->
<app-bulk-assign-dialog
  *ngIf="bulkAssignOpen()"
  [members]="bulkAssignMembers()"
  [courses]="bulkAssignCourses()"
  [coursesLoading]="bulkAssignCoursesLoading()"
  (closed)="closeBulkAssign()"
  (completed)="onBulkAssignCompleted()">
</app-bulk-assign-dialog>


